import React from "react";
import { VariableSizeList as List } from 'react-window';
import "../../../styles/components/chat/Sidebar.css";
import "../../../styles/components/chat/History.css";
import { Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import SidebarSkeleton from "../../skeleton/SidebarSkeleton";
import { useSearchParams } from "react-router-dom";

const Sidebar = ({ container, setContainer, chatlistcontainerRef, chatLists, newChatClicked, isLoading }) => {
  const [searchParams] = useSearchParams();
  
  // We don't need to extract items since chatLists is already the array of items
  const chatItems = Array.isArray(chatLists) ? chatLists : [];
  // Create a sizeMap to hold each item's height
const getItemSize = index => {
  const item = chatItems[index];
  if (item?.props?.className?.includes("chat-history-date")) {
    return 8; // smaller height for date
  }
  return 30; // larger height for chat item
};
  // Row renderer for virtualized list
// Update your ChatRow component
const ChatRow = ({ index, style }) => {
  return (
    <div 
      style={{
        ...style,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '5px 0'
      }}
    >
      {chatItems[index]}
    </div>
  );
};
  
  return (
    <>
      <div className="chat-sidebar">
        {!searchParams.get('chatId') && !searchParams.get('fastSearch') && (
          <div className="switch-container">
            <div className="scrollable-btn-group">
              <Button className={container === "Chat" ? "active" : ""} onClick={() => setContainer("Chat")}>Chat</Button>
              <Button className={container === "Browse" ? "active" : ""} onClick={() => setContainer("Browse")}>Search</Button>
              <Button className={container === "ScratchPad" ? "active" : ""} onClick={() => setContainer("ScratchPad")}>Scratch</Button>
              <Button className={container === "ReverseSearch" ? "active" : ""} onClick={() => setContainer("ReverseSearch")}>Reverse Search</Button>
              <Button className={container === "Agent" ? "active" : ""} onClick={() => setContainer("Agent")}>Agent</Button>
            </div>
          </div>
        )}
        
        {!searchParams.get('chatId') && (
          <div className="new-chat-container">
            <Button 
              className="btn-new-chat" 
              onClick={newChatClicked} 
              style={{ marginTop: '10px' }}
            >
              <Add />
              <span>Start New Chat</span>
            </Button>
          </div>
        )}
        
        {!searchParams.get('chatId') && (
          <div 
            ref={chatlistcontainerRef} 
            className="chat-history-container"
          >
            {isLoading ? (
              <SidebarSkeleton />
            ) : (
              chatItems.length > 0 ? (
                searchParams.get('fastSearch') ? (
                  <div className="custom-scrollbar">
                    {chatItems.map((item, index) => (
                      <div key={index} style={{ padding: '5px 0' }}>
                        {item}
                      </div>
                    ))}
                  </div>
                ) : (
                  <List
                    height={610}
                    itemCount={chatItems.length}
                    itemSize={getItemSize}
                    width={300}
                    overscanCount={5}
                    className="custom-scrollbar"
                  >
                    {ChatRow}
                  </List>
                )
              ) : null
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;